import {
	Button,
	CircularProgress,
	Modal,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@mui/styles";

import styled from "styled-components";

import TableRow from "@mui/material/TableRow";
import Input from "common/components/input";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTryUpdate,
} from "common/method/handleNotificationAlert";
import { useEffect, useState } from "react";
import { actionTypes as actionTypesList } from "redux/changebroker";
import { insert_change_broker } from "redux/changebroker/insert_change_broker";
import { actionTypes } from "redux/select_summaries";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"& td": {
		height: "50px !important",
		maxWidth: 150,
	},
	"& td div": {
		lineHeight: 1.8,
		textAlign: "center",
		borderRadius: 100,
		// color: 'white',
		display: "inline-block",
		width: 80,
		marginRight: 15,
		marginLeft: 15,
	},
	"&:nth-of-type(odd)": {},
	"&:last-child td, &:last-child th , &:last-child tr": {},
}));
let useStyles = makeStyles({
	header: {
		backgroundColor: "#ffffff",
		boxShadow: "lightgrey 0px 0px 10px",
	},
	modal: {
		display: "flex",
		// minHeight: 380,
		backgroundColor: "#ffffff",
		zIndex: 100,

		borderRadius: 5,
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		bgcolor: "background.paper",
		outline: 0,
		border: 0,
		boxShadow: 24,
	},
});
const ChangeSupervisor = ({ data, loadingList }) => {
	const dispatch = useDispatch();
	const summariesReducer = useSelector(
		(state) => state.select_summaries_reducer,
	);

	let classes = useStyles();
	const [element, setElement] = useState();
	const [searchTerm, setSearchTerm] = useState("");
	const [openModal, setOpenModal] = useState(false);
	const [loading, setLoading] = useState(false);

	const stockList = summariesReducer?.data?.map((item) => item?.body);

	const apiCall = () => {
		if (!element?.isin) return;
		let data = {
			isin: element?.isin,
		};

		setLoading(true);
		insert_change_broker({ data })
			.then((res) => handleNotificationAlertTryUpdate(res))
			.catch(() => handleNotificationAlertCatch())
			.finally(() => {
				setLoading(false);
				dispatch({
					type: actionTypesList.selectChangeBrokerAsync,
					payload: {},
				});
			});
	};

	const filterData = searchTerm
		? stockList?.filter(
				(item) =>
					Array.isArray(item?.full_name) &&
					item?.full_name?.map((name) =>
						name.toLowerCase().includes(searchTerm.toLowerCase()),
					),
		  )
		: stockList;

	useEffect(() => {
		dispatch({
			type: actionTypes?.select_summariesAsync,
			payload: {},
		});
	}, []);
	useEffect(() => {
		if (!searchTerm) return;
		dispatch({
			type: actionTypes?.select_summariesAsync,
			payload: {
				data: {
					full_name: searchTerm,
				},
			},
		});
	}, [searchTerm]);
	return (
		<div
			style={{
				width: "100%",
			}}>
			<div>
				<p style={{ marginBlockEnd: 16 }}>تغییر ناظر</p>
				<div className="flex items-center  justify-between flex-wrap ">
					<div>
						<Input
							className="flex-1"
							TextFieldStyle={{ minWidth: 200 }}
							label={`جستجوی نماد`}
							state={element}
							setState={setElement}
							autoCompleteCong={{
								options: filterData,
								getOptionLabel: (option) =>
									option?.full_name
										? String(option?.full_name)
										: String(option?.short_name),
							}}
							inputType={`muiAutocomplete`}
							disabled={false}
							placeholder={"انتخاب کنید"}
							onChangeText={(e) => setSearchTerm(e.target.value)}
						/>
					</div>

					<div style={{ marginInlineStart: 12, flex: 1, minWidth: 100 }}>
						<Button
							onClick={() => apiCall()}
							variant="contained"
							color="primary"
							className="p-1 m-0"
							disabled={loading || !element}>
							تغییر ناظر
						</Button>
					</div>
				</div>
				<TableContainer
					className={`mt-2 flex-1 ${classes["root"]}`}
					style={{ maxHeight: 400, overflow: "auto", minHeight: 300 }}>
					<Table
						aria-label="simple table"
						className={`${classes["tables"]} table-auto  overflow-auto`}>
						<TableHead className="sticky top-0 z-500 bg-gray-100">
							<TableRow>
								<TableCell align="center">نماد</TableCell>
								<TableCell align="center">تاریخ درخواست </TableCell>
								<TableCell align="center"> وضعیت </TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{data?.length !== 0 && (
								<>
									{data?.map((items, index) => {
										return (
											<StyledTableRow
												key={index}
												sx={{
													"&:last-child td, &:last-child th": {
														border: 0,
													},
													backgroundColor: index % 2 === 1 ? "#e1e1e155" : "",
												}}>
												<TableCell align="center">
													{items?.body?.insFarsiName || "-"}
												</TableCell>
												<TableCell align="center">
													{items?.body?.changeRequestDate || "-"}
												</TableCell>
												<TableCell align="center">
													{items?.body?.statusName || "-"}
												</TableCell>
											</StyledTableRow>
										);
									})}
								</>
							)}

							{loadingList && (
								<StyledTableRow>
									<TableCell align="center" colSpan={8}>
										<div className="w-100 text-center mt-5">
											<CircularProgress />
										</div>
									</TableCell>
								</StyledTableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				{data?.length === 0 && !loadingList && (
					<div
						style={{
							display: "flex",
							justifyContent: "center",
						}}>
						<TableCell align="center">
							<div className={classes["emptyCard"]}>تاریخچه ای یافت نشد</div>
						</TableCell>
					</div>
				)}
				<Modal
					open={openModal}
					onClose={() => {
						setOpenModal(false);
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description">
					<div className={classes["modal"]}>sdd</div>
				</Modal>
			</div>
		</div>
	);
};

export default ChangeSupervisor;
